import React from "react";
import { graphql } from "gatsby";
import Helmet from "react-helmet";
import ReactMarkdown from "react-markdown";

import Layout, { Container } from "../components/Layout";
import "../styles/obrazci.scss";

class ObrazciPage extends React.Component {
  render() {
    const {
      data: { obrazciPageData }
    } = this.props;
    // console.log(obrazciPageData);
    const {
      frontmatter: { content, group }
    } = obrazciPageData;
    return (
      <Layout title="Obrazci">
        <Helmet>
          <meta name="title" content={"seoTitle"} />
          <meta name="description" content={"seoDescription"} />
          <title>{"browserTitle"}</title>
        </Helmet>
        <Container>
          <ReactMarkdown escapeHtml={false} source={content} />
          <div className="obrazciPanel">
            {group.map((item, i) => {
              const { docs, name } = item;
              return (
                <div className="obrazciGroup">
                  <h3>{name} ({docs.length})</h3>
                  {docs.map(({ file, description }) => {
                    return (
                      <a href={file} target="_blank">
                        {description}
                      </a>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </Container>
      </Layout>
    );
  }
}

export default ObrazciPage;

export const obrazciQuery = graphql`
  query {
    obrazciPageData: markdownRemark(
      frontmatter: { templateKey: { eq: "obrazci" } }
    ) {
      frontmatter {
        content
        group {
          name
          docs {
            file
            description
          }
        }
      }
    }
  }
`;
